/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { JsonApiLinksDto } from "../JsonApiLinksDto";
import type { PaginationMeta } from "../PaginationMeta";

export type HierarchiesControllerGetChildrenPathParams = {
    /**
     * @description Parent scope ID
     * @type string
    */
    scopeId: string;
};

export const hierarchiesControllerGetChildrenQueryParamsScopeTypeEnum = {
    "ORGANIZATION": "ORGANIZATION",
    "PROMPT": "PROMPT",
    "FILE": "FILE",
    "PROJECT": "PROJECT",
    "SYSTEM": "SYSTEM",
    "WORKSPACE": "WORKSPACE",
    "TEAM": "TEAM",
    "FOLDER": "FOLDER",
    "USER": "USER",
    "CHAT_MESSAGE": "CHAT_MESSAGE",
    "CLIENT": "CLIENT",
    "THREAD": "THREAD",
    "PROJECT_TYPE": "PROJECT_TYPE",
    "OWNER": "OWNER",
    "ARCHITECT": "ARCHITECT",
    "DEPARTMENT": "DEPARTMENT",
    "REGION": "REGION",
    "CHECKLIST_TEMPLATE": "CHECKLIST_TEMPLATE",
    "TRIAL": "TRIAL",
    "CHANGE_ORDER": "CHANGE_ORDER",
    "SOURCE_RECORD": "SOURCE_RECORD",
    "all": "all"
} as const;

export type HierarchiesControllerGetChildrenQueryParamsScopeTypeEnumKey = (typeof hierarchiesControllerGetChildrenQueryParamsScopeTypeEnum)[keyof typeof hierarchiesControllerGetChildrenQueryParamsScopeTypeEnum];

export const hierarchiesControllerGetChildrenQueryParamsExcludeFileStatusesEnum = {
    "PENDING": "PENDING",
    "UPLOADING": "UPLOADING",
    "UPLOADED": "UPLOADED",
    "PROCESSING": "PROCESSING",
    "READY": "READY",
    "FAILED": "FAILED",
    "ARCHIVED": "ARCHIVED",
    "DELETED": "DELETED",
    "VERSIONED": "VERSIONED"
} as const;

export type HierarchiesControllerGetChildrenQueryParamsExcludeFileStatusesEnumKey = (typeof hierarchiesControllerGetChildrenQueryParamsExcludeFileStatusesEnum)[keyof typeof hierarchiesControllerGetChildrenQueryParamsExcludeFileStatusesEnum];

export const hierarchiesControllerGetChildrenQueryParamsFileDocumentTypesEnum = {
    "PRIME_CONTRACT": "PRIME_CONTRACT",
    "SUBCONTRACT": "SUBCONTRACT",
    "SPECIFICATIONS": "SPECIFICATIONS",
    "DRAWING": "DRAWING",
    "DRAWING_SET": "DRAWING_SET",
    "OTHER": "OTHER"
} as const;

export type HierarchiesControllerGetChildrenQueryParamsFileDocumentTypesEnumKey = (typeof hierarchiesControllerGetChildrenQueryParamsFileDocumentTypesEnum)[keyof typeof hierarchiesControllerGetChildrenQueryParamsFileDocumentTypesEnum];

export type HierarchiesControllerGetChildrenQueryParams = {
    /**
     * @description Type(s) of scope for filtering child scopes. Can be a single type or comma-separated list (e.g., FILE,FOLDER)
     * @type string | undefined
    */
    scopeType?: HierarchiesControllerGetChildrenQueryParamsScopeTypeEnumKey;
    /**
     * @description Maximum depth of hierarchy to retrieve
     * @minLength 1
     * @default 5
     * @type number | undefined
    */
    maxDepth?: number;
    /**
     * @description Load children lazily (returns links for children instead of full data)
     * @default false
     * @type boolean | undefined
    */
    lazyLoadChildren?: boolean;
    /**
     * @description Number of items per page
     * @minLength 1
     * @maxLength 100
     * @default 20
     * @type number | undefined
    */
    pageSize?: number;
    /**
     * @description Page number for offset-based pagination
     * @minLength 1
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @description Sort field and order. Entity-based sorts: \"name\"/\"-name\" (entity name, case-insensitive), \"entityCreatedAt\"/\"-entityCreatedAt\", \"entityUpdatedAt\"/\"-entityUpdatedAt\", \"entityCreatedByUser\"/\"-entityCreatedByUser\" (creator full name), \"entityUpdatedByUser\"/\"-entityUpdatedByUser\" (updater full name), \"entityDocumentType\"/\"-entityDocumentType\" (file document type, alphabetical by label). Scope-based sorts: \"createdAt\"/\"-createdAt\", \"updatedAt\"/\"-updatedAt\".
     * @type string | undefined
    */
    sort?: string;
    /**
     * @description Search term to filter children by entity name, and description/referenceNumber for projects (case-insensitive partial match)
     * @type string | undefined
    */
    search?: string;
    /**
     * @description Include soft-deleted entities (teams, organizations, clients) in the response. Default is false.
     * @default false
     * @type boolean | undefined
    */
    includeDeleted?: boolean;
    /**
     * @description Return only archived projects, folders and files. This is what the Archive listing reads; it overrides includeArchived.
     * @default false
     * @type boolean | undefined
    */
    archiveView?: boolean;
    /**
     * @description Include archived projects, folders and files in the response. Default is false, so an archived item leaves the active listing the way a deleted one does.
     * @default false
     * @type boolean | undefined
    */
    includeArchived?: boolean;
    /**
     * @description Include the scope itself (the scopeId used in the request) in the ancestor results. Default is false.
     * @default false
     * @type boolean | undefined
    */
    includeSelf?: boolean;
    /**
     * @description File statuses to exclude from results. Can be a single status or comma-separated list (e.g., \"PENDING,UPLOADING\")
     * @type array | undefined
    */
    excludeFileStatuses?: HierarchiesControllerGetChildrenQueryParamsExcludeFileStatusesEnumKey[];
    /**
     * @description Document types to filter FILE children by. Can be a single type or comma-separated list (e.g., \"PRIME_CONTRACT,SUBCONTRACT\"). Unlike excludeFileStatuses, this narrows results to files only — non-FILE children (folders) are excluded while it is active.
     * @type array | undefined
    */
    fileDocumentTypes?: HierarchiesControllerGetChildrenQueryParamsFileDocumentTypesEnumKey[];
    /**
     * @description Load entity data (folder.name, file.fileName, etc.) so results carry real display names. Set false when only counts/structure are needed, to skip the entity joins. Default is true; ignored (forced on) when a search term is present, since name filtering requires it.
     * @default true
     * @type boolean | undefined
    */
    includeEntities?: boolean;
};

export const dataTypeEnum3205 = {
    "hierarchies": "hierarchies"
} as const;

export type DataTypeEnum3205Key = (typeof dataTypeEnum3205)[keyof typeof dataTypeEnum3205];

export const attributesTypeEnum8 = {
    "ORGANIZATION": "ORGANIZATION",
    "TEAM": "TEAM",
    "PROJECT": "PROJECT",
    "FILE": "FILE",
    "FOLDER": "FOLDER",
    "CLIENT": "CLIENT"
} as const;

export type AttributesTypeEnum8Key = (typeof attributesTypeEnum8)[keyof typeof attributesTypeEnum8];

export const dataTypeEnum3206 = {
    "organizations": "organizations"
} as const;

export type DataTypeEnum3206Key = (typeof dataTypeEnum3206)[keyof typeof dataTypeEnum3206];

export const dataTypeEnum3207 = {
    "teams": "teams"
} as const;

export type DataTypeEnum3207Key = (typeof dataTypeEnum3207)[keyof typeof dataTypeEnum3207];

export const dataTypeEnum3208 = {
    "projects": "projects"
} as const;

export type DataTypeEnum3208Key = (typeof dataTypeEnum3208)[keyof typeof dataTypeEnum3208];

export const dataTypeEnum3209 = {
    "files": "files"
} as const;

export type DataTypeEnum3209Key = (typeof dataTypeEnum3209)[keyof typeof dataTypeEnum3209];

export const dataTypeEnum3210 = {
    "folders": "folders"
} as const;

export type DataTypeEnum3210Key = (typeof dataTypeEnum3210)[keyof typeof dataTypeEnum3210];

export const dataTypeEnum3211 = {
    "clients": "clients"
} as const;

export type DataTypeEnum3211Key = (typeof dataTypeEnum3211)[keyof typeof dataTypeEnum3211];

export const includedTypeEnum2149 = {
    "hierarchies": "hierarchies"
} as const;

export type IncludedTypeEnum2149Key = (typeof includedTypeEnum2149)[keyof typeof includedTypeEnum2149];

export const includedTypeEnum2150 = {
    "organizations": "organizations"
} as const;

export type IncludedTypeEnum2150Key = (typeof includedTypeEnum2150)[keyof typeof includedTypeEnum2150];

export const dataTypeEnum3212 = {
    "scopes": "scopes"
} as const;

export type DataTypeEnum3212Key = (typeof dataTypeEnum3212)[keyof typeof dataTypeEnum3212];

export const dataTypeEnum3213 = {
    "trial-summaries": "trial-summaries"
} as const;

export type DataTypeEnum3213Key = (typeof dataTypeEnum3213)[keyof typeof dataTypeEnum3213];

export const dataTypeEnum3214 = {
    "domains": "domains"
} as const;

export type DataTypeEnum3214Key = (typeof dataTypeEnum3214)[keyof typeof dataTypeEnum3214];

export const includedTypeEnum2151 = {
    "teams": "teams"
} as const;

export type IncludedTypeEnum2151Key = (typeof includedTypeEnum2151)[keyof typeof includedTypeEnum2151];

export const dataTypeEnum3215 = {
    "users": "users"
} as const;

export type DataTypeEnum3215Key = (typeof dataTypeEnum3215)[keyof typeof dataTypeEnum3215];

export const dataTypeEnum3216 = {
    "principals": "principals"
} as const;

export type DataTypeEnum3216Key = (typeof dataTypeEnum3216)[keyof typeof dataTypeEnum3216];

export const dataTypeEnum3217 = {
    "offices": "offices"
} as const;

export type DataTypeEnum3217Key = (typeof dataTypeEnum3217)[keyof typeof dataTypeEnum3217];

export const includedTypeEnum2152 = {
    "projects": "projects"
} as const;

export type IncludedTypeEnum2152Key = (typeof includedTypeEnum2152)[keyof typeof includedTypeEnum2152];

export const dataTypeEnum3218 = {
    "sample-project-templates": "sample-project-templates"
} as const;

export type DataTypeEnum3218Key = (typeof dataTypeEnum3218)[keyof typeof dataTypeEnum3218];

export const dataTypeEnum3219 = {
    "project-types": "project-types"
} as const;

export type DataTypeEnum3219Key = (typeof dataTypeEnum3219)[keyof typeof dataTypeEnum3219];

export const dataTypeEnum3220 = {
    "owners": "owners"
} as const;

export type DataTypeEnum3220Key = (typeof dataTypeEnum3220)[keyof typeof dataTypeEnum3220];

export const dataTypeEnum3221 = {
    "architects": "architects"
} as const;

export type DataTypeEnum3221Key = (typeof dataTypeEnum3221)[keyof typeof dataTypeEnum3221];

export const dataTypeEnum3222 = {
    "departments": "departments"
} as const;

export type DataTypeEnum3222Key = (typeof dataTypeEnum3222)[keyof typeof dataTypeEnum3222];

export const dataTypeEnum3223 = {
    "regions": "regions"
} as const;

export type DataTypeEnum3223Key = (typeof dataTypeEnum3223)[keyof typeof dataTypeEnum3223];

export const dataTypeEnum3224 = {
    "external-project-links": "external-project-links"
} as const;

export type DataTypeEnum3224Key = (typeof dataTypeEnum3224)[keyof typeof dataTypeEnum3224];

export const includedTypeEnum2153 = {
    "files": "files"
} as const;

export type IncludedTypeEnum2153Key = (typeof includedTypeEnum2153)[keyof typeof includedTypeEnum2153];

export const includedTypeEnum2154 = {
    "folders": "folders"
} as const;

export type IncludedTypeEnum2154Key = (typeof includedTypeEnum2154)[keyof typeof includedTypeEnum2154];

export const includedTypeEnum2155 = {
    "clients": "clients"
} as const;

export type IncludedTypeEnum2155Key = (typeof includedTypeEnum2155)[keyof typeof includedTypeEnum2155];

export const includedTypeEnum2156 = {
    "scopes": "scopes"
} as const;

export type IncludedTypeEnum2156Key = (typeof includedTypeEnum2156)[keyof typeof includedTypeEnum2156];

export const includedTypeEnum2157 = {
    "trial-summaries": "trial-summaries"
} as const;

export type IncludedTypeEnum2157Key = (typeof includedTypeEnum2157)[keyof typeof includedTypeEnum2157];

export const includedTypeEnum2158 = {
    "domains": "domains"
} as const;

export type IncludedTypeEnum2158Key = (typeof includedTypeEnum2158)[keyof typeof includedTypeEnum2158];

export const includedTypeEnum2159 = {
    "users": "users"
} as const;

export type IncludedTypeEnum2159Key = (typeof includedTypeEnum2159)[keyof typeof includedTypeEnum2159];

export const dataTypeEnum3225 = {
    "user-preferences": "user-preferences"
} as const;

export type DataTypeEnum3225Key = (typeof dataTypeEnum3225)[keyof typeof dataTypeEnum3225];

export const includedTypeEnum2160 = {
    "offices": "offices"
} as const;

export type IncludedTypeEnum2160Key = (typeof includedTypeEnum2160)[keyof typeof includedTypeEnum2160];

export const includedTypeEnum2161 = {
    "principals": "principals"
} as const;

export type IncludedTypeEnum2161Key = (typeof includedTypeEnum2161)[keyof typeof includedTypeEnum2161];

export const dataTypeEnum3226 = {
    "members": "members"
} as const;

export type DataTypeEnum3226Key = (typeof dataTypeEnum3226)[keyof typeof dataTypeEnum3226];

export const dataTypeEnum3227 = {
    "principalRoles": "principalRoles"
} as const;

export type DataTypeEnum3227Key = (typeof dataTypeEnum3227)[keyof typeof dataTypeEnum3227];

export const includedTypeEnum2162 = {
    "sample-project-templates": "sample-project-templates"
} as const;

export type IncludedTypeEnum2162Key = (typeof includedTypeEnum2162)[keyof typeof includedTypeEnum2162];

export const includedTypeEnum2163 = {
    "project-types": "project-types"
} as const;

export type IncludedTypeEnum2163Key = (typeof includedTypeEnum2163)[keyof typeof includedTypeEnum2163];

export const includedTypeEnum2164 = {
    "owners": "owners"
} as const;

export type IncludedTypeEnum2164Key = (typeof includedTypeEnum2164)[keyof typeof includedTypeEnum2164];

export const includedTypeEnum2165 = {
    "architects": "architects"
} as const;

export type IncludedTypeEnum2165Key = (typeof includedTypeEnum2165)[keyof typeof includedTypeEnum2165];

export const includedTypeEnum2166 = {
    "departments": "departments"
} as const;

export type IncludedTypeEnum2166Key = (typeof includedTypeEnum2166)[keyof typeof includedTypeEnum2166];

export const includedTypeEnum2167 = {
    "regions": "regions"
} as const;

export type IncludedTypeEnum2167Key = (typeof includedTypeEnum2167)[keyof typeof includedTypeEnum2167];

export const includedTypeEnum2168 = {
    "external-project-links": "external-project-links"
} as const;

export type IncludedTypeEnum2168Key = (typeof includedTypeEnum2168)[keyof typeof includedTypeEnum2168];

export const includedTypeEnum2169 = {
    "user-preferences": "user-preferences"
} as const;

export type IncludedTypeEnum2169Key = (typeof includedTypeEnum2169)[keyof typeof includedTypeEnum2169];

export const includedTypeEnum2170 = {
    "members": "members"
} as const;

export type IncludedTypeEnum2170Key = (typeof includedTypeEnum2170)[keyof typeof includedTypeEnum2170];

export const dataTypeEnum3228 = {
    "roles": "roles"
} as const;

export type DataTypeEnum3228Key = (typeof dataTypeEnum3228)[keyof typeof dataTypeEnum3228];

export const dataTypeEnum3229 = {
    "scope-access": "scope-access"
} as const;

export type DataTypeEnum3229Key = (typeof dataTypeEnum3229)[keyof typeof dataTypeEnum3229];

export const includedTypeEnum2171 = {
    "principalRoles": "principalRoles"
} as const;

export type IncludedTypeEnum2171Key = (typeof includedTypeEnum2171)[keyof typeof includedTypeEnum2171];

export type HierarchiesControllerGetChildren200 = {
    /**
     * @type array
    */
    data: {
        /**
         * @type string
        */
        id: string;
        type: DataTypeEnum3205Key;
        /**
         * @description Resource attributes (excluding relationships)
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            type?: AttributesTypeEnum8Key;
            parentId?: (string | null);
            /**
             * @type number | undefined
            */
            depth?: number;
            /**
             * @type string | undefined
            */
            path?: string;
            /**
             * @type boolean | undefined
            */
            private?: boolean;
            /**
             * @type string | undefined
            */
            name?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            archivedAt?: (string | null);
            organization?: (object | null);
            team?: (object | null);
            project?: (object | null);
            file?: (object | null);
            folder?: (object | null);
            client?: (object | null);
            /**
             * @type boolean | undefined
            */
            isArchived?: boolean;
            /**
             * @type string | undefined
            */
            itemCount?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            children?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3205Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            parent?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3205Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3206Key;
                });
            };
            /**
             * @type object | undefined
            */
            team?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3207Key;
                });
            };
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3208Key;
                });
            };
            /**
             * @type object | undefined
            */
            file?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3209Key;
                });
            };
            /**
             * @type object | undefined
            */
            folder?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3210Key;
                });
            };
            /**
             * @type object | undefined
            */
            client?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3211Key;
                });
            };
        };
    }[];
    /**
     * @description Additional resources referenced by the data
     * @type array | undefined
    */
    included?: ({
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2149Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            type: string;
            /**
             * @type string | undefined
            */
            parentId?: string;
            /**
             * @type string | undefined
            */
            depth?: string;
            /**
             * @type string | undefined
            */
            path?: string;
            /**
             * @type string | undefined
            */
            private?: string;
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            organization?: string;
            /**
             * @type string | undefined
            */
            team?: string;
            /**
             * @type string | undefined
            */
            project?: string;
            /**
             * @type string | undefined
            */
            file?: string;
            /**
             * @type string | undefined
            */
            folder?: string;
            /**
             * @type string | undefined
            */
            client?: string;
            /**
             * @type string | undefined
            */
            isArchived?: string;
            /**
             * @type string | undefined
            */
            itemCount?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            children?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3205Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            parent?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3205Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3206Key;
                });
            };
            /**
             * @type object | undefined
            */
            team?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3207Key;
                });
            };
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3208Key;
                });
            };
            /**
             * @type object | undefined
            */
            file?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3209Key;
                });
            };
            /**
             * @type object | undefined
            */
            folder?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3210Key;
                });
            };
            /**
             * @type object | undefined
            */
            client?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3211Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2150Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            salesforceId?: string;
            /**
             * @type string | undefined
            */
            trimbleIamAccountId?: string;
            /**
             * @type string | undefined
            */
            trimbleCdhAccountId?: string;
            /**
             * @type string | undefined
            */
            ssoEnabled?: string;
            /**
             * @type string | undefined
            */
            dataProtectionEnabled?: string;
            /**
             * @type string | undefined
            */
            organizationSkillsEnabled?: string;
            /**
             * @type string | undefined
            */
            emsValidationEnabled?: string;
            /**
             * @type string | undefined
            */
            archivedProjectChatEnabled?: string;
            /**
             * @type string | undefined
            */
            archivedContentChatEnabled?: string;
            /**
             * @type string | undefined
            */
            apiAccessEnabled?: string;
            /**
             * @type string | undefined
            */
            isInternal?: string;
            /**
             * @type string | undefined
            */
            enabledIntegrations?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
            /**
             * @type string | undefined
            */
            entitlement?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3212Key;
                });
            };
            /**
             * @type object | undefined
            */
            trial?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3213Key;
                });
            };
            /**
             * @type object | undefined
            */
            clients?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3211Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            domains?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3214Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            teams?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3207Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            folders?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3210Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            files?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3209Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            children?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3205Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            descendants?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3205Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2151Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            salesforceId?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3212Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3206Key;
                });
            };
            /**
             * @type object | undefined
            */
            members?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
            /**
             * @type object | undefined
            */
            sourceOffice?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3217Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2152Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            visibility?: string;
            /**
             * @type string | undefined
            */
            stage?: string;
            /**
             * @type string | undefined
            */
            location?: string;
            /**
             * @type string | undefined
            */
            startDate?: string;
            /**
             * @type string | undefined
            */
            endDate?: string;
            /**
             * @type string | undefined
            */
            description?: string;
            /**
             * @type string | undefined
            */
            value?: string;
            /**
             * @type string | undefined
            */
            referenceNumber?: string;
            /**
             * @type string | undefined
            */
            deliverable?: string;
            /**
             * @type string | undefined
            */
            deliveryMethod?: string;
            /**
             * @type string | undefined
            */
            division?: string;
            /**
             * @type string | undefined
            */
            details?: string;
            /**
             * @type string | undefined
            */
            imageUrl?: string;
            /**
             * @type string | undefined
            */
            workflowCount?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            status?: string;
            /**
             * @type string | undefined
            */
            itemCount?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3212Key;
                });
            };
            /**
             * @type object | undefined
            */
            archivedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            sampleProjectTemplate?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3218Key;
                });
            };
            /**
             * @type object | undefined
            */
            client?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3211Key;
                });
            };
            /**
             * @type object | undefined
            */
            projectType?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3219Key;
                });
            };
            /**
             * @type object | undefined
            */
            owner?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3220Key;
                });
            };
            /**
             * @type object | undefined
            */
            architect?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3221Key;
                });
            };
            /**
             * @type object | undefined
            */
            department?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3222Key;
                });
            };
            /**
             * @type object | undefined
            */
            region?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3223Key;
                });
            };
            /**
             * @type object | undefined
            */
            projectLead?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
            /**
             * @type object | undefined
            */
            externalLinks?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3224Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2153Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            fileUuid?: string;
            /**
             * @type string | undefined
            */
            originalName?: string;
            /**
             * @type string | undefined
            */
            fileName?: string;
            /**
             * @type string | undefined
            */
            mimeType?: string;
            /**
             * @type string | undefined
            */
            fileSize?: string;
            /**
             * @type string | undefined
            */
            checksum?: string;
            /**
             * @type string | undefined
            */
            bucket?: string;
            /**
             * @type string | undefined
            */
            fileKey?: string;
            /**
             * @type string | undefined
            */
            status?: string;
            /**
             * @type string | undefined
            */
            fileDocumentType?: string;
            /**
             * @type string | undefined
            */
            processingStartedAt?: string;
            /**
             * @type string | undefined
            */
            processingCompletedAt?: string;
            /**
             * @type string | undefined
            */
            pageCount?: string;
            /**
             * @type string | undefined
            */
            duration?: string;
            /**
             * @type string | undefined
            */
            dimensions?: string;
            /**
             * @type string | undefined
            */
            metadata?: string;
            /**
             * @type string | undefined
            */
            scopeType?: string;
            /**
             * @type string | undefined
            */
            version?: string;
            /**
             * @type string | undefined
            */
            versionName?: string;
            /**
             * @type string | undefined
            */
            versionDescription?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            isArchived?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3212Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
            /**
             * @type object | undefined
            */
            rootFile?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3209Key;
                });
            };
            /**
             * @type object | undefined
            */
            versions?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3209Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2154Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            itemCount?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3212Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
            /**
             * @type object | undefined
            */
            archivedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            archivedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2155Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3206Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3212Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3208Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2156Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string
            */
            type: string;
            /**
             * @type string | undefined
            */
            parentId?: string;
            /**
             * @type string | undefined
            */
            path?: string;
            /**
             * @type string | undefined
            */
            depth?: string;
            /**
             * @type string | undefined
            */
            private?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            parent?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3212Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3206Key;
                });
            };
            /**
             * @type object | undefined
            */
            team?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3207Key;
                });
            };
            /**
             * @type object | undefined
            */
            folder?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3210Key;
                });
            };
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3208Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2157Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            status?: string;
            /**
             * @type string | undefined
            */
            projectCount?: string;
            /**
             * @type string | undefined
            */
            projectCap?: string;
            /**
             * @type string | undefined
            */
            expiresAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: object;
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2158Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3206Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2159Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            email?: string;
            /**
             * @type string | undefined
            */
            firstName?: string;
            /**
             * @type string | undefined
            */
            lastName?: string;
            /**
             * @type string | undefined
            */
            phoneNumber?: string;
            /**
             * @type string | undefined
            */
            companyRole?: string;
            /**
             * @type string | undefined
            */
            acceptedTerms?: string;
            /**
             * @type string | undefined
            */
            termsAcceptedAt?: string;
            /**
             * @type string | undefined
            */
            lastLoginAt?: string;
            /**
             * @type string | undefined
            */
            timezone?: string;
            /**
             * @type string | undefined
            */
            avatarUrl?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            changeOrderAccess?: string;
            /**
             * @type string | undefined
            */
            trimbleSub?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            principal?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            preferences?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3225Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2160Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            uuid?: string;
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            salesforceId?: string;
            /**
             * @type string | undefined
            */
            isActive?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: object;
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2161Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            displayName?: string;
            /**
             * @type string
            */
            type: string;
            /**
             * @type string | undefined
            */
            cognitoSubs?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            user?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
            /**
             * @type object | undefined
            */
            memberships?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3226Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            createdFiles?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3209Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            roles?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3227Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2162Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            status?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: object;
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2163Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3206Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3212Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3208Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2164Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3206Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3212Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3208Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2165Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3206Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3212Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3208Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2166Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3206Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3212Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3208Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2167Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3206Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3212Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3208Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2168Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            provider?: string;
            /**
             * @type string | undefined
            */
            externalCompanyId?: string;
            /**
             * @type string | undefined
            */
            externalProjectId?: string;
            /**
             * @type string | undefined
            */
            scopeId?: string;
            /**
             * @type string | undefined
            */
            metadata?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3208Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2169Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            currentTeamId?: string;
            /**
             * @type string | undefined
            */
            theme?: string;
            /**
             * @type string | undefined
            */
            language?: string;
            /**
             * @type string | undefined
            */
            timezoneOverride?: string;
            /**
             * @type string | undefined
            */
            dashboardLayout?: string;
            /**
             * @type string | undefined
            */
            onboardingStatus?: string;
            /**
             * @type string | undefined
            */
            onboardingGoals?: string;
            /**
             * @type string | undefined
            */
            onboardingCompletedAt?: string;
            /**
             * @type string | undefined
            */
            skillsEducationDismissedAt?: string;
            /**
             * @type string | undefined
            */
            onboardingTaskCompletions?: string;
            /**
             * @type string | undefined
            */
            onboardingTasksLoginViews?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            user?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
            /**
             * @type object | undefined
            */
            currentTeam?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3207Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2170Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            membershipType?: string;
            /**
             * @type string | undefined
            */
            email?: string;
            /**
             * @type string | undefined
            */
            firstName?: string;
            /**
             * @type string | undefined
            */
            lastName?: string;
            /**
             * @type string | undefined
            */
            displayName?: string;
            /**
             * @type string | undefined
            */
            roleName?: string;
            /**
             * @type string | undefined
            */
            expiresAt?: string;
            /**
             * @type string | undefined
            */
            message?: string;
            /**
             * @type string | undefined
            */
            inviteStatus?: string;
            /**
             * @type string | undefined
            */
            isInherited?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            role?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3228Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3212Key;
                });
            };
            /**
             * @type object | undefined
            */
            principal?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            user?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3215Key;
                });
            };
            /**
             * @type object | undefined
            */
            invitedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            inheritedFrom?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3212Key;
                });
            };
            /**
             * @type object | undefined
            */
            scopeAccess?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3229Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2171Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            expiresAt?: string;
            /**
             * @type string | undefined
            */
            scopeType?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            principal?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3216Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3212Key;
                });
            };
            /**
             * @type object | undefined
            */
            role?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3228Key;
                });
            };
        };
    })[];
    /**
     * @type object | undefined
    */
    meta?: PaginationMeta;
    /**
     * @type object | undefined
    */
    links?: JsonApiLinksDto;
};

/**
 * @description Unauthorized
*/
export type HierarchiesControllerGetChildren401 = any;

/**
 * @description Forbidden - insufficient permissions
*/
export type HierarchiesControllerGetChildren403 = any;

export type HierarchiesControllerGetChildrenQueryResponse = HierarchiesControllerGetChildren200;

export type HierarchiesControllerGetChildrenQuery = {
    Response: HierarchiesControllerGetChildren200;
    PathParams: HierarchiesControllerGetChildrenPathParams;
    QueryParams: HierarchiesControllerGetChildrenQueryParams;
    Errors: HierarchiesControllerGetChildren401 | HierarchiesControllerGetChildren403;
};